export default __webpack_public_path__ + "static/media/Group 42616.da04333f.png";